export default __webpack_public_path__ + "static/media/unauthorized.516af99b.webp";